<script>
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Button from "../../ui/Button.svelte";
    import NumberInput from "../../ui/NumberInput.svelte";
    import TextInput from "../../ui/TextInput.svelte";
    import TextArea from "../../ui/TextArea.svelte";
    import CurrencyInput from "../../ui/CurrencyInput.svelte";
    import { v4 as uuidv4 } from 'uuid';

    export let type;

    const default_reward = {
        count: 1
    }

    let reward = {...default_reward};
    
    const dispatch = createEventDispatcher();

    function confirm() {
        reward.id = uuidv4();
        if(type != "lottery") {
            delete reward.count;
        }
        if(reward.type === "cash_voucher") {
            delete reward.name;
        } else if (reward.type === "product" || reward.type === "product_voucher") {
            delete reward.value;
        }
        dispatch("add", reward);
        reward = {...default_reward};
        edit = false;
    }
    
    function cancel() {
        edit = false;
    }

    function validate (r) {
        if (type === "lottery" && (!r.count || r.count == 0)) {
            return false
        }
        if (r.type === "cash_voucher" && !r.value) {
            return false
        } else if ((r.type === "product" || r.type === "product_voucher") && !r.name) {
            return false
        } else {
            return true
        }
    }

    $: valid = validate(reward);

    let edit = false;
</script>


<Dialog class="dialog" open={edit} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Belohnung hinzufügen</DialogTitle>
        <!-- <DialogDescription class="dialog-description">
        </DialogDescription> -->
        
        <form on:submit|preventDefault={confirm}>
            <label>Art
                <select bind:value={reward.type}>
                    <option value="product">Gratisprodukt</option>
                    <option value="cash_voucher">Wertgutschein</option>
                    <option value="product_voucher">Sachgutschein</option>
                </select>
            </label>
            {#if type === "lottery"}
                <NumberInput
                    label="Anzahl"
                    bind:value={reward.count}
                    min=1
                />
            {/if}
            {#if reward.type === "product"}
                <TextInput
                    label="Name des Produkts"
                    bind:value={reward.name}
                />
            {:else if reward.type === "cash_voucher"}
                <CurrencyInput
                    label="Wert des Gutscheins"
                    bind:value={reward.value}
                />
            {:else if reward.type === "product_voucher"}
                <TextInput
                    label="Gutschein für"
                    bind:value={reward.name}
                />
            {:else}
                Bitte wähle eine Art aus
            {/if}
            <TextArea
                label="Beschreibung (optional)"
                bind:value={reward.description}
            />
            
            <div class="dialog-options">
                <Button type="button" on:click={cancel}>
                    Abbrechen
                </Button>
                <Button type="submit" intent="primary" disabled={!valid}>
                    Hinzufügen
                </Button>
            </div>
        </form>
    </div>
</Dialog>

<Button type="button" intent="primary" on:click={() => {edit = true}}>
    Belohnung hinzufügen
</Button>